import { render, staticRenderFns } from "./athletes_dropdown.vue?vue&type=template&id=0ddd2216"
import script from "./athletes_dropdown.vue?vue&type=script&lang=js"
export * from "./athletes_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports